import { apiClient } from "../config/axios";

export interface ChatMessage {
    id?: string;
    role: "user" | "assistant" | "system"|"model";
    content: string;
    createdAt?: string;
}

export interface ChatHistoryResponse {
    sessionId: string;
    messages: ChatMessage[];
}

export const chatHistoryService = {
    async getHistory(sessionId: string, apiKey?: string, embedOrigin?: string): Promise<ChatMessage[]> {
        const headers: Record<string, string> = {};
        if (apiKey) headers["x-api-key"] = apiKey;
        if (embedOrigin) headers["x-embed-origin"] = embedOrigin;
        const { data } = await apiClient.get<ChatHistoryResponse>(
            `/v1/chat/${sessionId}`,
            { headers }
        );
        return data.messages;
    },
};
